export default __webpack_public_path__ + "static/media/0.4d5b67b6.png";